/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cardr": {
        "nested": {
          "issuing": {
            "nested": {
              "IssuerProcessor": {
                "values": {
                  "ISSUER_PROCESSOR_UNKNOWN_DO_NOT_USE": 0,
                  "I2C": 1,
                  "SQUARE_PAYMENT_GATEWAY": 2
                }
              },
              "BackingAccountToken": {
                "fields": {
                  "financialAccountToken": {
                    "type": "string",
                    "id": 1
                  }
                },
                "nested": {
                  "type": {
                    "oneof": ["financialAccountToken"]
                  }
                }
              },
              "CardState": {
                "values": {
                  "CARD_STATE_UNKNOWN_DO_NOT_USE": 0,
                  "ACTIVE": 1,
                  "DISABLED": 2,
                  "TERMINATED": 3,
                  "VERIFIED": 4,
                  "ISSUED": 5,
                  "UNDELIVERABLE": 6,
                  "SHIPPED": 7,
                  "CANCELLED": 8,
                  "REJECTED": 9,
                  "ORDERED": 10,
                  "LOST": 11,
                  "STOLEN": 12,
                  "RESTRICTED": 13,
                  "INACTIVE": 14,
                  "FRAUD_BLOCKED": 15
                }
              },
              "ReissueCardReason": {
                "values": {
                  "REISSUE_CARD_REASON_UNKNOWN_DO_NOT_USE": 0,
                  "DAMAGED": 1,
                  "EXPIRED": 2,
                  "LOST_STOLEN": 3,
                  "FRAUD_COMPROMISED": 4,
                  "RETURN": 5,
                  "NEW_ENROLLMENT": 6
                }
              },
              "CardHolderName": {
                "fields": {
                  "firstName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "middleName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CardHolderToken": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2
                  },
                  "customerId": {
                    "type": "string",
                    "id": 3
                  }
                },
                "nested": {
                  "type": {
                    "oneof": ["unitToken", "merchantToken", "customerId"]
                  }
                }
              },
              "ExpirationDate": {
                "fields": {
                  "month": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "year": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreditCardInfo": {
                "fields": {
                  "creditLimit": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BusinessInfo": {
                "fields": {
                  "businessNameOnCard": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerTaxIdNo": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "IssuedDate": {
                "fields": {
                  "year": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "month": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "day": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "IssuedCard": {
                "fields": {
                  "cardrCardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": ".squareup.cardr.issuing.CardHolderName",
                    "id": 2,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "expirationDate": {
                    "type": ".squareup.cardr.issuing.ExpirationDate",
                    "id": 4,
                    "rule": "optional"
                  },
                  "securityCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardState": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": ".squareup.cardr.issuing.IssuedCard.CardBrand",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": ".squareup.cardr.issuing.IssuedCard.CardType",
                    "id": 8,
                    "rule": "optional"
                  },
                  "fullPan": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": ".squareup.cardr.issuing.CardHolderToken",
                    "id": 10,
                    "rule": "optional"
                  },
                  "issuerProcessor": {
                    "type": ".squareup.cardr.issuing.IssuerProcessor",
                    "id": 11,
                    "rule": "optional"
                  },
                  "externalCardToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "creditCardInfo": {
                    "type": ".squareup.cardr.issuing.CreditCardInfo",
                    "id": 14,
                    "rule": "optional"
                  },
                  "businessInfo": {
                    "type": ".squareup.cardr.issuing.BusinessInfo",
                    "id": 15,
                    "rule": "optional"
                  },
                  "cardLocationIds": {
                    "type": "string",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "backingAccountToken": {
                    "type": ".squareup.cardr.issuing.BackingAccountToken",
                    "id": 17,
                    "rule": "optional"
                  },
                  "isActivated": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "issuedDate": {
                    "type": ".squareup.cardr.issuing.IssuedDate",
                    "id": 19,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "activatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 21,
                    "rule": "optional"
                  },
                  "closedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 22,
                    "rule": "optional"
                  },
                  "externalCardHolderToken": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "reissuedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  },
                  "reissueReason": {
                    "type": ".squareup.cardr.issuing.ReissueCardReason",
                    "id": 25,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardType": {
                    "values": {
                      "CARD_TYPE_UNKNOWN_DO_NOT_USE": 0,
                      "PHYSICAL": 1,
                      "VIRTUAL": 2
                    }
                  },
                  "CardBrand": {
                    "values": {
                      "CARD_BRAND_UNKNOWN_DO_NOT_USE": 0,
                      "VISA": 1,
                      "MASTERCARD": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuerProcessor && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.BackingAccountToken && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CardState && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ReissueCardReason && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CardHolderName && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CardHolderToken && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.ExpirationDate && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.CreditCardInfo && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.BusinessInfo && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuedDate && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuedCard && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuedCard?.nested?.CardType && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.IssuedCard?.nested?.CardBrand) {
  $root.addJSON(jsonData);
}

/**
 * Enumeration of issuer processors integrated with Cardr.
 *
 * SOURCE IssuerProcessor @ squareup/cardr/issuing/model.proto at 13:1
 */
export const IssuerProcessor = $root.lookupEnum('squareup.cardr.issuing.IssuerProcessor').values;
/**
 * SOURCE BackingAccountToken @ squareup/cardr/issuing/model.proto at 19:1
 */
export const BackingAccountToken = $root.lookupType('squareup.cardr.issuing.BackingAccountToken');
fixType(BackingAccountToken);
Builder.createAndAttachToType(BackingAccountToken);
/**
 * Internal mapping of card states agnostic of processor level states and
 * fulfillment statuses.
 *
 * SOURCE CardState @ squareup/cardr/issuing/model.proto at 28:1
 */
export const CardState = $root.lookupEnum('squareup.cardr.issuing.CardState').values;
/**
 * ReasonCodes recognized by i2c.
 * https://apis.i2cinc.com/apis/view-new-window/reissue-card?section=a7X7MzVA
 *
 * SOURCE ReissueCardReason @ squareup/cardr/issuing/model.proto at 51:1
 */
export const ReissueCardReason = $root.lookupEnum('squareup.cardr.issuing.ReissueCardReason').values;
/**
 * Sub-message type used for name fields to issuer processors.
 *
 * SOURCE CardHolderName @ squareup/cardr/issuing/model.proto at 63:1
 */
export const CardHolderName = $root.lookupType('squareup.cardr.issuing.CardHolderName');
fixType(CardHolderName);
Builder.createAndAttachToType(CardHolderName);
/**
 * The identifier for the owner of the card
 * Also the source of paying for the card
 *
 * SOURCE CardHolderToken @ squareup/cardr/issuing/model.proto at 71:1
 */
export const CardHolderToken = $root.lookupType('squareup.cardr.issuing.CardHolderToken');
fixType(CardHolderToken);
Builder.createAndAttachToType(CardHolderToken);
/**
 * Formatted date type used for expiration dates to issuer processors.
 *
 * SOURCE ExpirationDate @ squareup/cardr/issuing/model.proto at 85:1
 */
export const ExpirationDate = $root.lookupType('squareup.cardr.issuing.ExpirationDate');
fixType(ExpirationDate, {
  month: {
    required: true
  },
  year: {
    required: true
  }
});
Builder.createAndAttachToType(ExpirationDate);
/**
 * SOURCE CreditCardInfo @ squareup/cardr/issuing/model.proto at 97:1
 */
export const CreditCardInfo = $root.lookupType('squareup.cardr.issuing.CreditCardInfo');
fixType(CreditCardInfo);
Builder.createAndAttachToType(CreditCardInfo);
/**
 * SOURCE BusinessInfo @ squareup/cardr/issuing/model.proto at 102:1
 */
export const BusinessInfo = $root.lookupType('squareup.cardr.issuing.BusinessInfo');
fixType(BusinessInfo);
Builder.createAndAttachToType(BusinessInfo);
/**
 * Formatted date type used for card issued dates.
 *
 * SOURCE IssuedDate @ squareup/cardr/issuing/model.proto at 111:1
 */
export const IssuedDate = $root.lookupType('squareup.cardr.issuing.IssuedDate');
fixType(IssuedDate, {
  year: {
    required: true
  },
  month: {
    required: true
  },
  day: {
    required: true
  }
});
Builder.createAndAttachToType(IssuedDate);
/**
 * SOURCE IssuedCard @ squareup/cardr/issuing/model.proto at 125:1
 */
export const IssuedCard = $root.lookupType('squareup.cardr.issuing.IssuedCard');
fixType(IssuedCard, {
  cardrCardToken: {
    required: true
  }
});
Builder.createAndAttachToType(IssuedCard);
/**
 * SOURCE CardType @ squareup/cardr/issuing/model.proto at 126:3
 */
IssuedCard.CardType = $root.lookupEnum('squareup.cardr.issuing.IssuedCard.CardType').values;
/**
 * SOURCE CardBrand @ squareup/cardr/issuing/model.proto at 132:3
 */
IssuedCard.CardBrand = $root.lookupEnum('squareup.cardr.issuing.IssuedCard.CardBrand').values;